import AddressAutocompleteInput from "./AddressAutocompleteInput";

export default AddressAutocompleteInput;
